/**
 * Показываем ошибки для полей формы
 * @param {HTMLFormElement} form
 * @param {object} errors
 *
 * Объект с ошибками приходит в следующем формате:
 * {
 *     имя_поля: ["текст сообщения об ошибке"]
 * }
 */
export const formErrors = (form, errors) => {
    form.querySelectorAll('.form-group').forEach(function (formGroup) {
        formGroup.classList.remove('has-error');
        for (let errorItem in errors) {
            if (formGroup.querySelector(`[name="${errorItem}"]`)) {
                formGroup.classList.add('has-error');
                let helpBlock = formGroup.querySelector('.help-block');
                if (helpBlock && typeof errors[errorItem] !== 'undefined') {
                    helpBlock.innerText = errors[errorItem].join('<br>');
                }
            }
        }
    });
};

export default formErrors;
